import { render, staticRenderFns } from "./shopcart.vue?vue&type=template&id=925f7f9c&"
import script from "./shopcart.vue?vue&type=script&lang=js&"
export * from "./shopcart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports